<script>
export default {
    name: 'CertificateGeneratorIconFeedback',
    props: {
        isValid: { type: Boolean, required: true}
    }
};
</script>

<template>
    <div class="feedback-icon" :class="{'valid-feedback': isValid, 'invalid-feedback': !isValid}"></div>
</template>